import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../shared/base-new-request/base-new-request.model';
import {
  NONROTNewRequestControlName,
  NONROTNewRequestFormGroup,
  NONROTRequestInformationControlName,
} from './new-request-form.model';

@Injectable()
export class NONROTNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<NONROTNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [NONROTNewRequestControlName.ContactData]: true,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [NONROTNewRequestControlName.RequestInformation]: this.formBuilder.group({
        [NONROTRequestInformationControlName.WorksType]: [
          getDefaultControlValue(),
          Validators.required,
        ],
        [NONROTRequestInformationControlName.RequestDate]: [
          getDefaultControlValue(),
          Validators.required,
        ],
      }),
      [NONROTNewRequestControlName.CurrentInvestorName]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [NONROTNewRequestControlName.DocumentationForm]: [
        DocumentationFormType.NonElectronicForm,
        [Validators.required],
      ],
    });
  }
}
